export const DISABLED = 'disabled';
export const ONLINE = 'online';
export const OFFLINE = 'offline';
export const HIDDEN = 'hidden';
export const NONE = 'none';
